// Source identifiers sent to `POST /user/contact-us` so HubSpot submissions show
// where the user triggered the upgrade / contact flow (replaces "Conversion Page — Unavailable").
// Format: <page>.<cta_descriptor> — grep-friendly, human-readable.

export const UPGRADE_SOURCE = {
  // Navbar / global chrome
  NAVBAR_UPGRADE_BUTTON: 'navbar.upgrade_button',
  NAVBAR_CONTACT_US: 'navbar.contact_us',

  // Generic tile clicks
  TIER_CIRCLE_CLICK: 'tier_circle.click',
  TIERED_GHG_RATING_CIRCLE_CLICK: 'tiered_ghg_rating_circle.click',

  // Overlays
  RETIREMENT_INSIGHTS_UPGRADE_OVERLAY: 'retirement_insights.upgrade_overlay',
  SUPPLY_BRIDGE_UPGRADE_OVERLAY: 'supply_bridge.upgrade_overlay',
  UPCOMING_RATINGS_PAYWALL: 'upcoming_ratings.paywall_overlay',

  // Insights Hub / research
  INSIGHTS_HUB_LOCKED_NAV_ITEM: 'insights_hub.locked_nav_item',
  INSIGHTS_HUB_LOCKED_RESEARCH_UPDATE: 'insights_hub.locked_research_update',
  INSIGHTS_HUB_SEARCH_LOCKED_RESULT: 'insights_hub_search.locked_result',
  INSIGHTS_HUB_SEARCH_LOCKED_ENTER_PRESSED: 'insights_hub_search.locked_enter_pressed',
  INSIGHTS_HUB_ARTICLE_REDIRECT: 'insights_hub_article.access_denied_redirect',
  INSIGHTS_HUB_CATEGORY_LOCKED_RESEARCH_UPDATE_CARD:
    'insights_hub_category.locked_research_update_card',
  RESEARCH_UPDATE_REDIRECT: 'research_update.access_denied_redirect',
  CORSIA_REDIRECT: 'corsia.access_denied_redirect',
  ICVCM_REDIRECT: 'icvcm.access_denied_redirect',
  COMPLIANCE_CARD_LOCKED: 'compliance_card.locked',
  MARKET_UPDATE_REDIRECT: 'market_update.access_denied_redirect',
  UPDATES_LISTING_REDIRECT: 'updates_listing.access_denied_redirect',
  ARTICLE_THUMB_LOCKED: 'article_thumb.locked',
  ARTICLE_THUMB_LARGE_LOCKED: 'article_thumb_large.locked',

  // Home
  HOME_LATEST_BLOGS_LOCKED: 'home.latest_blogs.locked',

  // Credit Ratings (Search) page
  CREDIT_RATINGS_LIST_VIEW_LOCKED: 'credit_ratings.list_view_locked',
  CREDIT_RATINGS_CHART_VIEW_LOCKED: 'credit_ratings.chart_view_locked',
  CREDIT_RATINGS_SDG_RATING_LOCKED: 'credit_ratings.sdg_rating_locked',

  // Project pages
  PROJECT_ACTION_BAR_LOCKED_TAB: 'project.action_bar.locked_tab',
  PROJECT_GHG_RATING_LOCKED_PAGE: 'project.ghg_rating.locked_page',
  PROJECT_GHG_RATING_READ_MORE_MODAL: 'project.ghg_rating.read_more_modal',
  PROJECT_ESR_RATING_LOCKED_PAGE: 'project.esr_rating.locked_page',
  PROJECT_SDG_RATING_LOCKED_PAGE: 'project.sdg_rating.locked_page',
  PROJECT_EXEC_SUMMARY_PRICING_AND_SUPPLY_LOCKED:
    'project.executive_summary.pricing_and_supply_locked',
  PROJECT_EXEC_SUMMARY_ESR_WIDGET_LOCKED: 'project.executive_summary.esr_widget_locked',
  PROJECT_PRICING_AND_SUPPLY_LOCKED_CARD: 'project.pricing_and_supply.locked_card',
  PROJECT_SCREENER_AI_CREDITS_CARD: 'project_screener.ai_credits_card',

  // Upgrade page
  UPGRADE_PAGE_TOP_CONTACT_US: 'upgrade.top_contact_us',
  UPGRADE_PAGE_BOTTOM_CONTACT_US: 'upgrade.bottom_contact_us',
  UPGRADE_PAGE_ESSENTIALS_PLAN: 'upgrade.essentials_plan_cta',
  UPGRADE_PAGE_EXPERT_PLAN: 'upgrade.expert_plan_cta',

  // Developer portal
  DEVELOPER_PORTAL_CONTACT_FORM: 'developer_portal.contact_form',

  // Generic modals
  PAYWALL_MODAL_REQUEST_UPGRADE: 'paywall_modal.request_upgrade',
  UPGRADE_MODAL_REQUEST_UPGRADE: 'upgrade_modal.request_upgrade',

  // Demo (magic-link) banner
  DEMO_BANNER_CONTACT_US: 'demo.contact_us',
} as const;

export type UpgradeSource = (typeof UPGRADE_SOURCE)[keyof typeof UPGRADE_SOURCE];
